export default "__VITE_ASSET__BdVGduIl__"